import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllDeliveryMethods(page, limit) {
  return httpClient.get(`/merchant/delivery-methods?page=${page}&limit=${limit}`);
}

/**
 *
 * @param deliveryMethodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getDeliveryMethod(deliveryMethodId) {
  return httpClient.get(`/merchant/delivery-methods/${deliveryMethodId}`);
}

/**
 *
 * @param deliveryMethodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteDeliveryMethod(deliveryMethodId) {
  return httpClient.delete(`/merchant/delivery-methods/${deliveryMethodId}`);
}

/**
 *
 * @param deliveryMethodId
 * @param delivery_method
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateDeliveryMethod(deliveryMethodId, delivery_method) {
  return httpClient.put(`/merchant/delivery-methods/${deliveryMethodId}`, delivery_method);
}

/**
 *
 * @param delivery_method
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newDeliveryMethod(delivery_method) {
  return httpClient.post('/merchant/delivery-methods', delivery_method);
}

// Merchant Specific APIs ends
// =========================================
